import Vue from "vue";
import Vuex from "vuex";

//模块
import auth from "./modules/auth";
import dict from "./modules/dict";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    dict
  }
});
